// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header___95Cv","footer":"ModalInfo_footer__hJ6Dv"};